export default "__VITE_ASSET__b59aa016__"